'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_UserPreferences$$anon$21(ps$13) {
  this.a6A = null;
  this.a6A = ps$13;
}
export { $c_Lmealorama_UserPreferences$$anon$21 as $c_Lmealorama_UserPreferences$$anon$21 };
$p = $c_Lmealorama_UserPreferences$$anon$21.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_UserPreferences$$anon$21;
/** @constructor */
function $h_Lmealorama_UserPreferences$$anon$21() {
}
export { $h_Lmealorama_UserPreferences$$anon$21 as $h_Lmealorama_UserPreferences$$anon$21 };
$h_Lmealorama_UserPreferences$$anon$21.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6A.a.length;
});
$p.g = (function(i) {
  return this.a6A.a[i];
});
var $d_Lmealorama_UserPreferences$$anon$21 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_UserPreferences$$anon$21, "mealorama.UserPreferences$$anon$21", ({
  Hc: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_UserPreferences$$anon$21 as $d_Lmealorama_UserPreferences$$anon$21 };
//# sourceMappingURL=mealorama.-User-Preferences$$anon$21.js.map
